import React from "react";

// Assets
import ImageContactMeBanner from "assets/images/banners/contact-me-banner.jpg";

// Components
import LandingBanner from "components/LandingBanner/LandingBanner";
import Footer from "components/Footer/Footer";
import ContactForm from "components/ContactForm/ContactForm";

function ContactMePage() {
  return (
    <div className="contactMePage">
      <div className="contactMePage__banner">
        <LandingBanner title={"Contact Me"} banner={ImageContactMeBanner} />
      </div>
      <div className="contactMePage__content">
        <ContactForm />
      </div>
      <div className="contactMePage__footer">
        <Footer />
      </div>
    </div>
  );
}

export default ContactMePage;
